import store from "../index.js";
import router from "../../router/index";
import api from "../../utils/api";

const host = process.env.VUE_APP_HOST;

export const modules = {
  store,
};

export const state = {
  _analyze: [],
  _price: [],
  _pdf: [],
  _ownerPdf: [],
  _report: [],
  _progress: {
    state: false,
    value: 5,
    title: "등기부등본 넘기는중...",
    type: 1,
    is: true,
  },
  _items: {
    act_score: 0,
  },
};

export const mutations = {
  setProgress(state, value) {
    state._progress.value = value;
  },
  setProgressState(state, type) {
    state._progress.state = type;
    if (!type) {
      state._progress.value = 5;
      state._progress.title = "등기부등본 넘기는중...";
      state._progress.type = 1;
      state._progress.is = true;
    }
  },
  setProgressTitle(state, type) {
    state._progress.title = type;
  },
  setProgressType(state, type) {
    state._progress.type = type;
  },
  setProgressIs(state, type) {
    state._progress.is = type;
  },

  setEstateAnalyze(state, response) {
    state._analyze = response;
  },
  setPriceAnalyze(state, response) {
    console.log("response", response);
    state._price = response;
  },
  setDocumentDownload(state, response) {
    console.log("response", response);
    state._pdf = response;
  },
  setOwnerDocumentDownload(state, response) {
    console.log("response", response);
    state._ownerPdf = response;
  },

  setSubscribeAnalyze(state, item) {
    state._analyze = [];
    item.addressBase = `
        ${item.addressSi} ${item.addressGu} ${item.addressDong} ${item.buildingName ?? ""} ${item.buildingDong ?? ""} ${
      item.buildingHo ?? ""
    } ${item.buildingFloor ?? ""}`;
    state._analyze = Object.assign([], item);
  },
  setActScore(state, item) {
    state._items.act_score = item;
  },
};

export const actions = {
  acProgressState({ commit }, type) {
    commit("setProgressState", type);
  },
  acProgressValue({ commit }, value) {
    commit("setProgress", value);
  },
  acActScore({ commit }, item) {
    commit("setActScore", item);
  },
  async acReportAnalyze({ commit }, payload) {
    const url = `${host}/api/v1/estate-analyze`;
    try {
      const res = await api.post(url, payload);
      return { code: res?.data?.code, msg: res?.data?.message };
    } catch (err) {
      console.log("err", err);
      return { code: err.data.code, msg: err.data.message };
    }
  },
  async acReportUniqueNoAnalyze({ commit }, payload) {
    const url = `${host}/api/v1/estate-analyze/unique-no`;
    try {
      const res = await api.post(url, payload);
      return { code: res?.data?.code, msg: res?.data?.message };
    } catch (err) {
      console.log("err", err);
      return { code: err.data.code, msg: err.data.message };
    }
  },
  async acEstateAnalyze({ commit, state }, params) {
    const url = `${host}/api/v1/estate/analyze`;
    try {
      const res = await api.post(url, params, {
        onUploadProgress: async progressEvent => {
          commit("setProgressState", true);

          const updateInterval = 100;
          const progressIncrement = 0.1;
          const maxProgress = 95;

          while (state._progress.value < maxProgress) {
            await new Promise(resolve => setTimeout(resolve, updateInterval));
            state._progress.value = Math.min(state._progress.value + progressIncrement, maxProgress);
          }
        },
        onDownloadProgress: progressEvent => {
          commit("setProgress", 100);
        },
      });
      console.log("acEstateAnalyze res", res);
      commit("setEstateAnalyze", res.data.data);
      return res.data;
    } catch (error) {
      if ((error?.status ?? error?.response?.status) === 401) {
        localStorage.clear();
        router.push("/");
      }
      return null;
    }
  },
  async acRevertColdStatus({ commit }, { cart_seq }) {
    const url = `${host}/api/v1/estate-analyze/revert-cold`;
    try {
      const res = await api.post(url, { cart_seq });
      return res.data;
    } catch (error) {
      return null;
    }
  },

  async acEstateAnalyzeOwner({ commit }, params) {
    const url = `${host}/api/v1/estate/analyze/owner`;
    try {
      const res = await api.post(url, params, {
        onUploadProgress: async progressEvent => {
          const updateInterval = 100;
          const progressIncrement = 0.1;
          const maxProgress = 95;

          while (state._progress.value < maxProgress) {
            await new Promise(resolve => setTimeout(resolve, updateInterval));
            state._progress.value = Math.min(state._progress.value + progressIncrement, maxProgress);
          }
        },
        onDownloadProgress: progressEvent => {
          commit("setProgress", 100);
        },
      });
      console.log("야아아아아아아아아", res.data.data);
      commit("setOwnerDocumentDownload", res.data.data);
      return res.data;
    } catch (error) {
      if ((error?.status ?? error?.response?.status) === 401) {
        localStorage.clear();
        router.push("/");
      }
      return null;
    }
  },

  async acOwnerAnalyzeMaual({ commit }, params) {
    const url = `${host}/api/v1/estate/analyze/owner/manual`;

    try {
      const res = await api.post(url, params);

      return res.data.data;
    } catch (error) {
      if ((error?.status ?? error?.response?.status) === 401) {
        localStorage.clear();
        router.push("/");
      }
      return null;
    }
  },

  async acPriceAnalyze({ commit }, params) {
    console.log("acPriceAnalyze", params);

    const url = `${host}/api/v1/price/analyze`;
    try {
      const res = await api.post(url, params, {
        onUploadProgress: async progressEvent => {
          state._progress.value = 5;
          for (let i = 0; i < 1000; i++) {
            await new Promise(resolve => setTimeout(resolve, 100));
            if (state._progress.value < 95) {
              state._progress.value += 0.1;
            } else {
              break;
            }
          }
        },
        onDownloadProgress: progressEvent => {
          commit("setProgress", 100);
        },
      });
      console.log("acPriceAnalyze res", res);

      commit("setPriceAnalyze", res.data.data);
      return res.data;
    } catch (error) {
      if ((error?.status ?? error?.response?.status) === 401) {
        localStorage.clear();
        router.push("/");
      }
      return null;
    }
  },
  async acDocumentDownload({ commit, state }, params) {
    console.log("acDocumentDownload", params);

    const url = `${host}/api/v1/estate/analyze/document`;
    try {
      const res = await api.post(url, params, {
        onUploadProgress: async progressEvent => {
          commit("setProgressState", true);

          for (let i = 0; i < 1000; i++) {
            await new Promise(resolve => setTimeout(resolve, 100));
            if (state._progress.value < 95) {
              state._progress.value += 0.1;
            } else {
              break;
            }
          }
        },
        onDownloadProgress: progressEvent => {
          commit("setProgress", 100);
        },
      });
      console.log("acDocumentDownload res", res);

      commit("setDocumentDownload", res.data.data);
      return res.data;
    } catch (error) {
      console.log("에러뭐냐", error);
      if ((error?.status ?? error?.response?.status) === 401) {
        localStorage.clear();
        router.push("/");
      }
      return null;
    }
  },
  async acSubscribeDocumentDownload({ commit, state }, params) {
    console.log("acDocumentDownload", params);

    const url = `${host}/api/v1/estate/subscribe/document`;
    try {
      const res = await api.post(url, params, {
        onUploadProgress: async progressEvent => {
          commit("setProgressState", true);

          for (let i = 0; i < 1000; i++) {
            await new Promise(resolve => setTimeout(resolve, 100));
            if (state._progress.value < 95) {
              state._progress.value += 0.1;
            } else {
              break;
            }
          }
        },
        onDownloadProgress: progressEvent => {
          commit("setProgress", 100);
        },
      });
      console.log("acDocumentDownload res", res);

      commit("setDocumentDownload", res.data.data);
      return res.data;
    } catch (error) {
      console.log("에러뭐냐", error);
      if ((error?.status ?? error?.response?.status) === 401) {
        localStorage.clear();
        router.push("/");
      }
      return null;
    }
  },
  async acOrderSave({}, forms) {
    const url = `${host}/api/v1/report`;
    console.log("forms", forms[0]);
    try {
      const res = await api.post(url, forms[0]);
      return res.data.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acOrderFileSave({}, forms) {
    const url = !forms.get("owner")
      ? `${host}/api/v1/report-file/admin/save`
      : `${host}/api/v1/report-file/admin/save/owner`;

    console.log("forms", forms);
    try {
      const res = await api.post(url, forms);
      return res.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acOrderFileDocumentSave({}, body) {
    const url =
      body.type === "default"
        ? `${host}/api/v1/report-file/admin/document-save`
        : `${host}/api/v1/report-file/admin/document-save/owner`;

    console.log("body", body);
    try {
      const res = await api.post(url, body);
      console.log(res.data);
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acOrderUpdate({}, { report_seq, body }) {
    const url = `/api/v1/report/${report_seq}`;
    try {
      const res = await api.patch(url, body);
      return res.data?.code === 0 ? true : res.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acOrderFileUpdate({}, { file_seq, form, type }) {
    let owner_file_seq;
    if (type) {
      owner_file_seq = file_seq;
    }
    const url = !type
      ? `/api/v1/report-file/admin/update/${file_seq}`
      : `/api/v1/report-file/admin/update/owner/${owner_file_seq}`;

    try {
      await api.patch(url, form);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acOrderCommentSave({}, body) {
    const url = `/api/v1/report-comment/admin/save`;
    try {
      await api.post(url, body);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },

  async acOrderCommentUpdate({}, { comment_seq, body }) {
    const url = `/api/v1/report-comment/admin/update/${comment_seq}`;
    try {
      await api.patch(url, body);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },

  async acReportChecked({}, seq) {
    const url = `/api/v1/report/checked?cart_seq=${seq}`;
    try {
      const res = await api.get(url);
      return res.data.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },

  async acReportRestoreDelete({}, body) {
    const url = `/api/v1/report/admin/restore`;
    try {
      const res = await api.delete(url, {
        data: body,
      });
      return res.data.affected;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acSubscribeAnalyze({ commit }, analyze_seq) {
    try {
      const url = `/api/v1/subscribe-analyze/${analyze_seq}`;
      const res = await api.get(url);
      commit("setSubscribeAnalyze", res.data.data[0]);
    } catch (error) {
      console.log("acSubscribeAnalyze", error.response);
      return false;
    }
  },
  async acSubscribeAnalyzeFileUpdate({ commit }, forms) {
    const url = `/api/v1/subscribe-analyze-file/update`;
    try {
      return await api.patch(url, forms);
    } catch (err) {
      console.log("err", err);
      return null;
    } finally {
      console.log(commit);
    }
  },
  async acSubscribeAnalyzeUpdate({}, { analyze_seq, body }) {
    const url = `/api/v1/subscribe-analyze/report/${analyze_seq}`;
    try {
      const res = await api.patch(url, body);
      return res.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acAnalyzeCommentSave({}, body) {
    const url = `/api/v1/subscribe-analyze-comment`;
    try {
      await api.post(url, body);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acAnalyzeCommentUpdate({}, { comment_seq, body }) {
    const url = `/api/v1/subscribe-analyze-comment/${comment_seq}`;
    try {
      await api.patch(url, body);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acSubscribeAnalyzeConfirm({}, body) {
    const url = `${host}/api/v1/subscribe-analyze/status/${body.analyze_seq}`;
    try {
      await api.patch(url, { is_status: body.is_status });
      return true;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acColdReportLog({}, paylod) {
    const url = `/api/v1/report-cold-log`;
    try {
      await api.post(url, paylod);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acColdReportAutoApprove({}, paylod) {
    const url = `/api/v1/report-cold-log/autoapprove`;
    try {
      await api.post(url, paylod);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acReportPreviewAuth({}, querys) {
    const url = `/api/v1/user/report-preview/auth?member_no=${querys.user_no}&cart_seq=${querys.cart_seq}`;
    try {
      const res = await api.get(url);
      if (res?.data?.code === 0) {
        return res.data.data?.token;
      }
      return false;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acReportRunFirstDeposit({}, { report_seq }) {
    const url = `/api/v1/report/first-deposit/${report_seq}`;
    try {
      const res = await api.post(url);
      return res.data;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
